import { FC } from 'react';
import AccessPasswordsDrawer from 'components/organisms/AccessPasswordsDrawer';
import ConfirmModal from 'components/molecules/ConfirmModal';
import ConfirmCloseAccessPasswordModal from 'components/molecules/ConfirmDeleteAccessPasswordModal';
import CheckInCreateRoomDrawer from 'components/organisms/CheckInCreateRoomDrawer';
import CheckInRoomForceSaveModal from 'components/organisms/CheckInRoomForceSaveModal';
import CheckInScannerQRModal from 'components/organisms/CheckInScannerQRModal';
import DeviceHelpDrawer from 'components/organisms/DeviceHelpDrawer';
import UpdateAccessPasswordErrorModal from 'components/molecules/UpdateAccessPasswordErrorModal';
import { useAccess } from './resources/useAccess';
import Access from './Access';
import ListInvitationsModal from './Access/ListInvitationsModal';
import CreateInvitationModal from './Access/CreateInvitationModal';

const TabAccesses: FC = () => {
  const {
    assetId,
    devices,
    currentDevice,
    accessColumn,
    invitations,
    pageNumber,
    form,
    createModalTranslations,
    drawerTranslations,
    adminPasswords,
    adminAvailablePasswords,
    nfcPasswords,
    userPasswords,
    userAvailablePasswords,
    deleteModalTranslations,
    closeModalTranslations,
    listInvitationsModalTranslations,
    listInvitationItemTranslations,
    assignRoomButtonText,
    checkInPropsStates,
    controlsDeviceHelpDrawer,
    formDeviceHelpDrawerDescriptionState,
    formDeviceHelpDrawerTitleState,
    updateErrorModalConfig,
    onOpenAssignRoomDrawer,
    onOpenCreateInvitationModal,
    onCloseCreateInvitationModal,
    onCloseInvitationsListModal,
    onOpenInvitationsListModal,
    onLoadMore,
    onRevoke,
    onClosePasswordsDrawer,
    onClosePasswordsDrawerModal,
    onConfirmClosePasswordDrawer,
    onTogglePassword,
    onChangePassword,
    onCloseDeleteModal,
    onDeletePassword,
    onClickConfirmDeletingPassword,
    onClickAddPassword,
    onSavePasswordsChanges,
    onConfirmCloseDrawerModalWithoutSaving,
    onGetSensorsList,
    isAssignRoomButtonVisible,
    loading,
    loadingAccesses,
    createInvitationModalVisible,
    invitationListModalVisible,
    drawerPasswordVisible,
    adminPasswordsAddButtonVisible,
    userPasswordsAddButtonVisible,
    nfcPasswordsAddButtonVisible,
    confirmDeletingModalVisible,
    closeDrawerModalVisible,
    adminSectionVisible,
    userSectionVisible,
    nfcSectionVisible,
    loadingUpdate,
    saveButtonDisabled,
    showLoadMoreInvitationsButton,
    isCreateAndListInvitationsForbidden,
  } = useAccess();
  const {
    titleText,
    createInvitationButtonText,
    createInvitationInfoButtonText,
    listInvitationButtonText,
    listInvitationInfoButtonText,
    updateAccessListText,
  } = createModalTranslations;
  const {
    deleteModalTitle,
    deleteModalText,
    deleteModalMainButtonText,
    deleteModalSecondaryButtonText,
  } = deleteModalTranslations;
  const {
    closeModalTitle,
    closeModalText,
    closeModalMainButtonText,
    closeModalSecondaryButtonText,
  } = closeModalTranslations;
  const { title: listInvitationsModalTitle, closeButtonText, loadMoreButtonText } = listInvitationsModalTranslations;
  const {
    literals,
    onClickConfirmUpdateRetry,
    onCloseUpdateErrorModal,
    isUpdateErrorModalVisible,
    list,
  } = updateErrorModalConfig;

  return (
    <>
      <Access
        accessColumn={accessColumn}
        devices={devices}
        form={form}
        title={titleText}
        createInvitationButtonText={createInvitationButtonText}
        createInvitationInfoText={createInvitationInfoButtonText}
        listInvitationsButtonText={listInvitationButtonText}
        listInvitationsInfoText={listInvitationInfoButtonText}
        updateButtonText={updateAccessListText}
        assignRoomButtonText={assignRoomButtonText}
        loading={loading}
        onOpenCreateInvitation={onOpenCreateInvitationModal}
        onOpenInvitationsListModal={onOpenInvitationsListModal}
        onRefresh={onGetSensorsList}
        isCreateAndListInvitationsForbidden={isCreateAndListInvitationsForbidden}
        onClickAssignRoom={onOpenAssignRoomDrawer}
        isAssignRoomButtonVisible={isAssignRoomButtonVisible}
      />
      <CheckInCreateRoomDrawer {...checkInPropsStates} />
      <CheckInRoomForceSaveModal {...checkInPropsStates.modalForce} />
      <CheckInScannerQRModal {...checkInPropsStates.qrModal} />
      <ListInvitationsModal
        key={'listInvitation'}
        invitations={invitations}
        pageNumber={pageNumber}
        onClose={onCloseInvitationsListModal}
        onLoadMore={onLoadMore}
        onRevoke={onRevoke}
        loading={loadingAccesses}
        visible={invitationListModalVisible}
        showLoadMoreInvitationsButton={showLoadMoreInvitationsButton}
        title={listInvitationsModalTitle}
        closeButtonText={closeButtonText}
        loadMoreButtonText={loadMoreButtonText}
        itemTranslations={listInvitationItemTranslations}
      />
      <CreateInvitationModal
        key={'createInvitation'}
        assetId={assetId}
        visible={createInvitationModalVisible}
        onClose={onCloseCreateInvitationModal}
      />
      <AccessPasswordsDrawer
        device={currentDevice}
        adminPasswords={adminPasswords}
        adminAvailablePasswords={adminAvailablePasswords}
        nfcPasswords={nfcPasswords}
        userPasswords={userPasswords}
        userAvailablePasswords={userAvailablePasswords}
        onClose={onClosePasswordsDrawer}
        onTogglePassword={onTogglePassword}
        onChangePassword={onChangePassword}
        onDeletePassword={onDeletePassword}
        onClickAddPassword={onClickAddPassword}
        onSave={onSavePasswordsChanges}
        visible={drawerPasswordVisible}
        adminSectionVisible={adminSectionVisible}
        userSectionVisible={userSectionVisible}
        nfcSectionVisible={nfcSectionVisible}
        adminPasswordsAddButtonVisible={adminPasswordsAddButtonVisible}
        userPasswordsAddButtonVisible={userPasswordsAddButtonVisible}
        nfcPasswordsAddButtonVisible={nfcPasswordsAddButtonVisible}
        translations={drawerTranslations}
        loading={loadingUpdate}
        disabled={saveButtonDisabled}
      />
      <DeviceHelpDrawer
        {...controlsDeviceHelpDrawer}
        formDeviceHelpDrawerDescriptionState={formDeviceHelpDrawerDescriptionState}
        formDeviceHelpDrawerTitleState={formDeviceHelpDrawerTitleState}
      />
      <ConfirmModal
        loading={false}
        onCancel={onCloseDeleteModal}
        onClickMainButton={onClickConfirmDeletingPassword}
        mainButtonText={deleteModalMainButtonText}
        secondaryButtonText={deleteModalSecondaryButtonText}
        text={deleteModalText}
        title={deleteModalTitle}
        visible={confirmDeletingModalVisible}
      />
      <UpdateAccessPasswordErrorModal
        loading={loadingUpdate}
        onCancel={onCloseUpdateErrorModal}
        onClickMainButton={onClickConfirmUpdateRetry}
        mainButtonText={literals.updateErrorModalMainButtonText}
        secondaryButtonText={literals.updateErrorModalSecondaryButtonText}
        text={literals.updateErrorModalText}
        title={literals.updateErrorModalTitle}
        visible={isUpdateErrorModalVisible}
        list={list}
      />
      <ConfirmCloseAccessPasswordModal
        loading={false}
        onCancel={onConfirmCloseDrawerModalWithoutSaving}
        onClickMainButton={onConfirmClosePasswordDrawer}
        onClickSecondaryButton={onClosePasswordsDrawerModal}
        mainButtonText={closeModalMainButtonText}
        secondaryButtonText={closeModalSecondaryButtonText}
        text={closeModalText}
        title={closeModalTitle}
        visible={closeDrawerModalVisible}
      />
    </>
  );
};

export default TabAccesses;
